import * as React from 'react'
import TermMonthScoreView from './TermMonthScoreView'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { inject } from 'mobx-react'
import { ITermMonthScore } from '../../../Model/Questionnaire'

export interface ITermsMonthsScoreViewProps {
    terms: Array<ITermMonthScore>,
    className?: string
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
export default class TermsMonthsScoreView extends React.Component<ITermsMonthsScoreViewProps> {
    render() {
        const { terms, className, localizationStore } = this.props

        return (
            <div className={className}>
                <div className="row">
                    <div className="col-12">
                        <p>{localizationStore!.t!('TermsMonthsScoreViewHeader')}</p>
                        <hr />
                    </div>
                    {
                        terms.map(
                            x => <TermMonthScoreView className="col-sm-12 col-md-6" key={x.Duration} term={x} />
                        )
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Score/TermsMonthsScoreView.tsx